import ErrorFallbacks from "@src/components/ErrorFallbacks";
import React from "react";
import { quitWebviewDeeplink } from "@src/utils/goBack";

const ServerTimeout = () => {
  return <ErrorFallbacks statusCode={408} />;
};

ServerTimeout.getLayoutProps = () => ({
  handleBack: quitWebviewDeeplink,
  noPullToRefresh: true,
  noFooter: true,
});
export default ServerTimeout;
